/* const cart = {
    "token": "Z2NwLXVzLWVhc3QxOjAxSFhZTlNBRTdGSEo4Q0dTV1FOTTFaMzla",
    "attributes": {
        "token":"aswdfjddwkpdfro"
    },
    "items": [
        {
            "variant_id": 41053851123847,
            "quantity": 1
        },
        {
            "variant_id": 41052579922055,
            "quantity": 1
        },
        {
            "variant_id": 41052930179207,
            "quantity": 1
        }
    ]
} */

let action = 'update'
$(document).ready(async function(){
  return
    console.log("-------------");
  console.log("1. Obtener el customer id"+ __st.cid);
  console.log("------------");
    const Id = __st.cid
    if(Id != undefined){
      let cart = await getSavedCart()
      console.log("-------------");
      console.log("2. Obtener el carrito");
      console.log(cart);
      console.log("------------");
      // aquí se hace la consulta y se obtiene el objeto cart
      let pageCart = await nccheckCartAttributes()
      console.log('tokens')
      console.log(cart.attributes.token + ' - ' + pageCart.token)
      if(cart != null){
        if(cart.attributes.token){
            if(cart.attributes.token != pageCart.token){
              //if(cart.items.length > 0){
                console.log('cart- se hace el update') 
                await ncupdateCart(cart)
                console.log('cart - se termina de cargar')
                //ncupdateCart()
                let pageCart = await nccheckCartAttributes()
                console.log('att '+pageCart.logged)
                if(pageCart.logged == "true" || pageCart.logged == "false"){
                  uploadCart()
                }
              //}
            }
        }
      }
    }
})

async function getSavedCart(){
  return
    let data = {
        "customerId": __st.cid+''
    }
    let res
    await fetch('https://social.samaya.mx/api/shasa/cart-get', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shasa-Token': 'sha-tk-ysx5Yl3Vss7ScUZvsVpT',
            'X-Sha-Tk':'sha-20012607-samyaz'
        },
        body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(error => { throw new Error(error.message); });
            }
            return response.json();
        })
        .then(data => {
          console.log('Success:', data);
          res = data
        })
        .catch(error => {
          action = 'update'
          return null
        });
        let lines = []
        for(const item of res.cart.line_items){
            lines.push({
                "variant_id": item.variant_id,
                "quantity": item.qty
            })
        }
        let cart = {
            "attributes": {
                "token":res.cart.token
            },
            "items": lines
        }
        return cart
}

async function uploadCart(){
  return
  console.log('Se hace el upload')
    setTimeout(async () => {
        let newCart = await nccheckCartAttributes(true)
        console.log('uploaded cart:')
        console.log(newCart)
        let lines = []
        for(item of newCart.items){
            lines.push({"variantId": item.variant_id,
                    "qty": item.quantity})
        }
        var data = {
            "customerId": __st.cid+'',
            "token": newCart.attributes.token,
            "action": action,
            "lineItems": lines
        }
        fetch('https://social.samaya.mx/api/shasa/cart-update', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        'X-Shasa-Token': 'sha-tk-ysx5Yl3Vss7ScUZvsVpT',
            'X-Sha-Tk':'sha-20012607-samyaz'
        },
        body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(error => { throw new Error(error.message); });
            }
            return response.json();
        })
        .then(data => {
          console.log('Success:', data);
        })
    }, 500);
}

async function ncaddToken() {
  return
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  const charactersLength = characters.length;

  for (let i = 0; i < 20; i++) {
      token += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  const Id = __st.cid
  if(Id != undefined){
      var attributes = {
          "attributes": {
              "token": token
          }
      };
  }else{
      var attributes = {
          "attributes": {
              "token": token,
              'logged':'false'
          }
      };
  }

  console.log('Sending attributes to cart:', attributes);

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(attributes)
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(error => { throw new Error(error.message); });
    }
    return response.json();
  })
  .then(async data => {
    console.log('Success:', data);
    await nccheckCartAttributes(); // Verificar los atributos después de agregarlos
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('Error adding custom attributes: ' + error.message);
  });
}

  async function nccheckCartAttributes(cart=false) {
    return
    let attributes = 'test'
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
      console.log('Cart Attributes:', data.attributes);
        var zero = data.items.some(item => item.price === 0);
        if(zero){
          disableCheckout()
          checkoutMessage()
        }
        else{
          enableCheckout()
        }
        if(cart){
            attributes = data
        }
        else{
            attributes = data.attributes
        }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return attributes
  }

  async function ncgetCurrentCart() {
    return
    console.log('cart - entra a getCurrentCart')
    return await fetch('/cart.js')
      .then(response => response.json())
      .catch(error => console.error('Error getting current cart:', error));
  }
  

  async function ncupdateCart(cart) {
    return
    console.log('cart - entra a updateCart')
    console.log(cart)
    await ncgetCurrentCart().then(async currentCart => {
        console.log(currentCart)
      if (!currentCart) return;
  
      let newAttributes = cart.attributes;
      let newItems = cart.items;
  
      if (currentCart.attributes.logged === 'false') {
        console.log('cart - no estaba logged in')
        let itemsToAdd = [];
  
        newItems.forEach(newItem => {
          let existsInCurrentCart = currentCart.items.some(currentItem => currentItem.variant_id == newItem.variant_id);
  
          if (!existsInCurrentCart) {
            itemsToAdd.push({
                variant_id: newItem.variant_id,
              quantity: newItem.quantity
            });
          }
        });
  
        if (itemsToAdd.length > 0) {
            await ncaddItemsToCart(itemsToAdd, newAttributes);
        } else {
            await ncupdateCartAttributes(newAttributes);
        }
      } else{
        console.log('cart - si estaba logged in')
        await ncreplaceCartItemsAndAttributes(newItems, newAttributes);
      }
    });
  }
  
  async function ncaddItemsToCart(items, attributes) {
    return
    let updates = { updates: {} };
    console.log('items' + JSON.stringify(items))
    items.forEach(item => {
      updates.updates[item.variant_id] = item.quantity;
    });
  
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(updates)
    })
    .then(response => response.json())
    .then(() => ncupdateCartAttributes(attributes))
    .then(async data => {
      await ncupdateCartAttributes(attributes)
        console.log('cart - se actualizo el carrito items');
        await updateCart()
      })
    .catch(error => console.error('Error adding items to cart:', error));
  }
  
  async function ncupdateCartAttributes(attributes) {
    return
    console.log('cart - attributes')
    console.log(attributes)
    attributes.logged = 'true'
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    })
    .then(response => response.json())
    .then(data => console.log('Cart attributes updated:', data))
    .then(data => {
        console.log('cart - se actualizo el carrito attributes');
        //updateCart()
      })
    .catch(error => console.error('Error updating cart attributes:', error));
  }
  
  async function ncreplaceCartItemsAndAttributes(items, attributes) {
    return
    // Primero vaciar el carrito actual
    await fetch('/cart/clear.js', {
      method: 'POST'
    })
    .then(async () => {
      // Luego agregar los nuevos items
      await ncaddItemsToCart(items, attributes);
    })
    .catch(error => console.error('Error clearing cart:', error));
  }
  